/**
 * HHT1 TimeLine Contents 정보
 * @type {string[]}
 */

export const HHT1_EP15_ANSWERS = [
    'Today’s class is about medicine in ancient Rome. But Holly can’t think well. She feels ill.',
    'Suddenly, Holly is in ancient Rome! She is worried because there aren’t any hospitals. ',
    'The Roman teacher tells Holly she will have to go home.',
    'Holly’s classmates want to go home, too. They pretend to be ill.',
    'Stephanie takes Holly home in a Roman chariot, and Holly goes to bed.',
    'Harry is worried about Holly and asks what’s the matter with her. Holly says she has a fever and needs medicine.',
    'Harry mixes together wine, pepper, honey, and eggs. He tells Holly to spread it on her skin. He thinks it will make Holly better.',
    'But Holly doesn’t want to do it. She screams and suddenly wakes up in class shouting out something about pigeons.',
    'It was all a dream. Everyone in Holly’s class is very confused. They think it’s funny and laugh at Holly. ',
    'It’s a long time in the future. A girl who looks like Holly has a fever.',
    'She uses an amazing machine to make her better, and it only takes a few seconds!',
    'The girl’s mom, who looks like Stephanie, tells her that people used to get shots to get better.',
    'The girl can’t believe that people used to put needles in their skin!',

];

// export const HHT1_EP15_ANSWER_SOUNDS = [
//     '/1_EP15_SB_TL_01.mp3',
//     '/1_EP15_SB_TL_02.mp3',
//     '/1_EP15_SB_TL_03.mp3',
//     '/1_EP15_SB_TL_04.mp3',
//     '/1_EP15_SB_TL_05.mp3',
//     '/1_EP15_SB_TL_06.mp3',
//     '/1_EP15_SB_TL_07.mp3',
//     '/1_EP15_SB_TL_08.mp3',
//     '/1_EP15_SB_TL_09.mp3',
//     '/1_EP15_SB_TL_10.mp3',
//     '/1_EP15_SB_TL_11.mp3',
//     '/1_EP15_SB_TL_12.mp3',
//     '/1_EP15_SB_TL_13.mp3',
// ];

export const HHT1_EP15_ANSWER_SOUNDS = [
    '/a7ae4c1db0fbaeffeb20fd6e07883609.mp3',
    '/7f8651fd54cbd955166591babef379dd.mp3',
    '/1e099e86ffb2538c218009d25bbede73.mp3',
    '/f4178621a3ea0705e68c5df52e910c66.mp3',
    '/63278e875229cb2e3f3efaad4691105c.mp3',
    '/b54a884eca8087f8e46e90b1885e862c.mp3',
    '/778a4efbd1c42335654a086ba0b0ff4a.mp3',
    '/87b8873d5691322f57efe66b0a4fca30.mp3',
    '/e2d824036fb10642e233c1e6f6d0d549.mp3',
    '/c4e25cb59c615aa04bce6873765226bb.mp3',
    '/ee7feb257a26140d8e8a47784a51b7db.mp3',
    '/a373df385127e9e5346ef7d7276c992d.mp3',
    '/80dd02f6ecd76354d9bd3198667c82b1.mp3',
];

export const HHT1_EP15_QUIZ_ITEMS = [{
    'A': HHT1_EP15_ANSWERS[12],
    'B': HHT1_EP15_ANSWERS[1],
    'SoundIndexA': 12,
    'SoundIndexB': 1,
    'answer': HHT1_EP15_ANSWERS[1],
    'sound': [2],
    'exception': false,
},
    {
        'A': HHT1_EP15_ANSWERS[10],
        'B': HHT1_EP15_ANSWERS[3],
        'SoundIndexA': 10,
        'SoundIndexB': 3,
        'answer': HHT1_EP15_ANSWERS[3],
        'sound': [4],
        'exception': false,
    },
    {
        'A': HHT1_EP15_ANSWERS[5],
        'B': HHT1_EP15_ANSWERS[0],
        'SoundIndexA': 5,
        'SoundIndexB': 0,
        'answer': HHT1_EP15_ANSWERS[5],
        'sound': [6, 7],
        'exception': false,
    },
    {
        'A': HHT1_EP15_ANSWERS[2],
        'B': HHT1_EP15_ANSWERS[8],
        'SoundIndexA': 2,
        'SoundIndexB': 8,
        'answer': HHT1_EP15_ANSWERS[8],
        'sound': [9, 10],
        'exception': true,
    },
    {
        'A': HHT1_EP15_ANSWERS[11],
        'B': HHT1_EP15_ANSWERS[4],
        'SoundIndexA': 11,
        'SoundIndexB': 4,
        'answer': HHT1_EP15_ANSWERS[11],
        'sound': [12],
        'exception': false,
    },

]
